var SVGNote = require('../base'),
    SignatureNoteModel = require('../signature'),
    GraphicTextStampShapeModel = require('../../../../../../../canvas/models/textStamp'),
    GraphicTextStampShapeView = require('../../../../../../../canvas/views/shape/textStamp/shapeView'),
    GraphicStampNoteView = require('../../../../../../views/note/textStamp/view'),
    NoteUIModel = require('./uiModel'),
    TextStampModel = require('../../../../../../../user/stamps/textStamp'),
    $ = require('jquery');



module.exports = SVGNote.extend({

    constructor: function() {

        this.existingStamp = null; // ( set on parse and set on UI model if not new ) .... see parse

        SVGNote.apply( this, arguments );

    },

    autoDisplayApplies: false, // for consistency with graphic stamps

    NoteUIModel: NoteUIModel,
    ShapeModel: GraphicTextStampShapeModel,
    ViewConstructor: GraphicStampNoteView,
    SUPPORTS_COLOR_PICKER: 1,
    init: 'J',
    createHotKey: 'j', // ( no good choices available -- so random )
    desc: 'Text Stamp',
    actionTitle: 'Text Stamp',
    defaultSubType: 'text_stamp',

    // This currently only has one color: not sure what would happen if we implement backgrounds ( then there would be 2 )
    defaultShapeColor: NoteUIModel.prototype.defaults.textColor,
    defaultSVGAttrsEdit: SignatureNoteModel.prototype.defaultSVGAttrsEdit,

    // We should refactor this to used a factor so it's no longer a model function
    shapeView: function( options ) {
        return new GraphicTextStampShapeView( options );

    },
    iconClass: 'icon-font-1', // TODO: get better one and update font files ( also need update of graphic to differentiate )

    /**
     * We want to recreate the uiModel here ( at least ), so it's updated with the approp. values post save.
     * At least do this 1st for testing without having to read in and out -- should refactor however.
     * ( this was on the uiModel.selectedStamp )
     * uiModel is created on init ... REFACTOR ...
     *  TODO: prob want to create the shapes on parse; outline workarounds ( need to look at shape and UI model )
     */
    parse: function( attrs ) {

        attrs = SVGNote.prototype.parse.apply( this, arguments );

        // could use import - get shape models to render here and create a shape model first, but I don't think necessary ... just get the data from the svg
        // need stamp from SVG
        var isNew = !attrs.sequence;

        if ( !isNew ) {

            var svg = attrs.text;
            var $svg = $(svg); // utilize jquery to parse the svg

            /**
             * Always get all non text related attributes that we need at the top level element;
             * Get those specific to text ( font, font size ); from the text element
             * Later we may have a background - in which case wed' have to get the attributes from a rect ( with an identifier if > 1 )
             * The alternative is putting every single attribute we will need to know into data attributes.
             * For now it is save to assume there will be a single text element.
             * At first used $topLevelElement for settings but now we have the data attributes.
             */

            var textElement = $svg.find('g text')[0];

            var $stamp = $svg.find('stamp');

            // Version: in future, if version is different than the default current,
            // may need to switch-track -- maybe only be necessary for parsing the XML
            // Modified stamps would be stored with the newest update to date version.
            // Change if/when necessary -- maybe store the original on the modified stamp model/as the originalVersion on the uiModel
            var version = $stamp.find('version').text();

            var rotation = parseFloat( $stamp.find('rotation').text() );
            var subject = $stamp.find('subject').text();
            var template = $stamp.find('template').text();

            var stamp = new TextStampModel({
                src: template, // sets aVariables ( need to set the values on here )
                subject: subject, // use data attributes; I think this is all we need
                id: 0  // we store the original id but it is meaningless here ... give it one of 0 ( which doesn't exist in the db and can be used to tell if new/not new )
            });

            /**
             * Variables: Create object who's keys are the variable keys and values are the variable values
             * Store this on the UI model.
             */
            var oVariables = {};
            var $variables = $svg.find('variables');
            if ( $variables.length > 0 ) {
                $variables.children().each( function() {
                    oVariables[ $(this).attr('key') ] = $(this).text();
                } );
            }

            /**
             * Tokens -- do the same as variables
             * ( we don't want to replace existing values that were printed, etc ).
             */

            var oTokens = {};
            var $tokens = $svg.find('tokens');
            if ( $tokens.length > 0 ) {
                $tokens.children().each( function() {
                    oTokens[ $(this).attr('key') ] = $(this).text();
                } );
            }

            var fontSize = parseFloat( textElement.getAttribute('font-size') ); // TODO: stored in px -- LEAVE THAT WAY or allow ???
            var fontFamily = textElement.getAttribute('font-family');
            var textColor = textElement.getAttribute('fill');

            var textOpacity = textElement.getAttribute('opacity');
            if ( textOpacity === null ) { // if a value of 1, it isn't written on export
                textOpacity = 1.0;
            }

            var stampPlaced = true; // must be tried by nature

            /* Hack b/c UI model not yet init'd ( it has to be put in parse or vice versa ) */
            /* Store these values here for now then on init on UI model they'll be set */
            // this.version = version; -- now not passing setting -- any existing stamp would be saved with the latest version
            this.existingStamp = stamp;
            this.rotationAtZeroPageRotation = rotation;
            this.fontSize = fontSize;
            this.fontFamily = fontFamily;
            this.textColor = textColor;
            this.textOpacity = textOpacity;
            this.stampPlaced = stampPlaced; // must be true by definition
            this.originalVariables = Object.keys( oVariables ).length > 0 ? oVariables : null;
            this.originalTokens = Object.keys( oTokens ).length > 0 ? oTokens : null;

            // Would occur for those not created on load of page currently ( eg newly saved ) --
            // INIT OF THE MODEL AND UI MODEL IS NOT CALLED AGAIN CURRENTLY
            if ( this.uiModel ) {

                // Variables and tokens must be set prior to the selected stamp -- clear old values here too

                this.uiModel.setOriginalStampVariableInputs(  Object.keys( oVariables ).length > 0 ? oVariables : null );

                this.uiModel.setOriginalTokenValues(  Object.keys( oTokens ).length > 0 ? oTokens : null );

                this.uiModel.setSelectedStamp( this.existingStamp ); // may need to take setting the values out of here )

                this.uiModel.set({
                    //version: version, -- now not setting
                    rotationAtZeroPageRotation: rotation,
                    fontSize: fontSize,
                    font: fontFamily,
                    stampPlaced: stampPlaced,
                    textColor: textColor,
                    textOpacity: textOpacity
                });

            }

        }

        return attrs;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/svg/textStamp/model.js
 ** module id = 320
 ** module chunks = 0
 **/